import * as React from 'react';

import { useStaleBuildPrompt } from '../hooks/useStaleBuildPrompt';

const StaleBuildPrompt: React.FC = () => {
  useStaleBuildPrompt();
  return null;
};

interface IStaleBuildPromptGateProps {
  enabled: boolean;
}

export const StaleBuildPromptGate: React.FC<IStaleBuildPromptGateProps> = ({ enabled }) =>
  enabled ? <StaleBuildPrompt /> : null;
